import { render, staticRenderFns } from "./ImageGroupDetails.vue?vue&type=template&id=2f4ec320&scoped=true"
import script from "./ImageGroupDetails.vue?vue&type=script&lang=js"
export * from "./ImageGroupDetails.vue?vue&type=script&lang=js"
import style0 from "./ImageGroupDetails.vue?vue&type=style&index=0&id=2f4ec320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4ec320",
  null
  
)

export default component.exports